module.exports = __webpack_public_path__ + "img/DemoMaths.5e2f5725.png";